var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Logo'),_c('ProductDetail'),(_vm.loading)?_c('Loading'):_vm._e(),(_vm.dataAvailable)?_c('div',[_c('ProductDetail',{attrs:{"product":_vm.product}})],1):_vm._e(),(!_vm.dataAvailable && !_vm.loading)?_c('div',[_c('NoData')],1):_vm._e(),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }